/**
 * Pure helpers for working with ShipmentContainer data.
 */
/**
 * Returns a short user-facing identifier for a container — prefers the serial number
 * (e.g. a scanned license plate) when present, falling back to the internal containerId.
 */
export var getContainerDisplayId = function (container) { return (container.containerSeqNum || container.serialNumber || container.containerId) + (container.containerAssocTypeEnumId === 'ScatAdopted' ? " from #" + (container.serialNumber || container.containerId) : ''); };
